/*
  Fires `express_checkout_clicked` when a shopper taps a wallet button (Shop Pay,
  Apple Pay, Google Pay) in the cart drawer. Answers "how many people used
  express checkout" for the `cart-express-checkout` test.

  Only variant-a renders the wallets, so control can never fire this. That is
  the point of the number (usage of the thing the variant adds), not a
  comparison between arms; the test's verdict stays on conversion rate.

  Shopify draws the wallets itself, partly in shadow DOM and partly in iframes,
  so a plain click listener on the page sees only some taps:
  - Shadow DOM: a pointerdown inside it is retargeted to the host element and
    reaches a listener on the wrapper.
  - Iframes: nothing inside reaches this page, but the tap moves focus into the
    iframe, so the window blurs while document.activeElement is inside the
    wrapper: the iframe itself, or the wallet's own element when the iframe
    sits in a closed shadow root (activeElement stops at the host).
  Both are watched, and a short guard stops one tap counting twice.
*/
(function () {
  'use strict';

  var WRAPPER = '.cart-drawer__express';
  var GUARD_MS = 1500;
  var lastSent = 0;

  // Best-effort wallet name from the element that was tapped (a custom element
  // tag, an iframe title or its src). 'wallet' when it cannot tell.
  function walletOf(el) {
    var text = '';
    for (var n = el; n && n !== document.body; n = n.parentNode || n.host) {
      if (n.nodeType !== 1) continue;
      text += ' ' + (n.tagName || '') + ' ' + (n.getAttribute('title') || '') + ' ' + (n.getAttribute('src') || '') +
        ' ' + (n.getAttribute('aria-label') || '');
      if (n.matches && n.matches(WRAPPER)) break;
    }
    text = text.toLowerCase();
    if (/shop[-_ ]?pay|shopify[-_ ]?pay/.test(text)) return 'shop_pay';
    if (/apple/.test(text)) return 'apple_pay';
    if (/google|gpay/.test(text)) return 'google_pay';
    if (/paypal/.test(text)) return 'paypal';
    return 'wallet';
  }

  function send(el) {
    var now = Date.now();
    if (now - lastSent < GUARD_MS) return;
    lastSent = now;
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('express_checkout_clicked', { wallet: walletOf(el) });
      }
    } catch (e) {
      /* analytics must never block the payment sheet */
    }
  }

  // Shadow DOM wallets: the event's path starts inside the host, and the host
  // sits inside the wrapper.
  document.addEventListener(
    'pointerdown',
    function (event) {
      var path = event.composedPath ? event.composedPath() : [event.target];
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (n && n.matches && n.matches(WRAPPER)) {
          send(path[0] && path[0].nodeType === 1 ? path[0] : n);
          return;
        }
      }
    },
    true
  );

  // Iframe wallets: focus moves into the iframe and this window blurs.
  window.addEventListener('blur', function () {
    setTimeout(function () {
      var active = document.activeElement;
      if (active && active !== document.body && active.closest && active.closest(WRAPPER)) send(active);
    }, 0);
  });
})();
